// VolumePayment.tsx
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
declare global {
  interface Window {
    Volume: any
  }
}
interface Props {
  amount: number,
  reference: string, 
  merchantPaymentId: string
 
}


const VolumePayment: React.FC <Props>=({
   amount,
  reference, 
  merchantPaymentId,

}) =>{

      const navigate = useNavigate()
  
  useEffect(() => {
    // Charger dynamiquement le script Volume si non présent
    const existingScript = document.querySelector(
      'script[src="https://js.volumepay.io"]'
    )
    const loadVolume = () => {
      if (!window.Volume) {
        console.log("Volume SDK non chargé")
        return
      }
      const volume = new window.Volume({
        environment: "SANDBOX", // ou "SANDBOX"
        applicationId: "dbf2bc7e-aabf-412a-ac03-a96bcfef456d",
        eventConsumer: (event:any) => {  console.log("A VOLUME EVENT: " + event) 
          if(event==='payment_failed_qr')
          {
            navigate(`/volume/success?status=FAILED&merchantPaymentId=${merchantPaymentId}`)
          }

        },  
      //  errorConsumer: (error:any) => { console.log('onErreur event',JSON.stringify(error)) },
      //  payLabel: "Pay $", // used for translations; default "Pay by Bank App"     		
       // agentType: "WEB_BROWSER" // not required
     
        
      })
      // Injection du composant Volume dans le div
      volume.injectDesktopComponent(
        "volume-container", // id du div
        "FR",               // pays
        "EUR",              // devise
        amount,               // montant
        reference,
        merchantPaymentId,
        { mydata: "myvalue" } // metadata optionnelle

     )
    }
    if (!existingScript) {
      const script = document.createElement("script")
      script.src = "https://js.volumepay.io"
      script.async = true
      script.onload = loadVolume
      document.body.appendChild(script)
    } else {
      loadVolume()
    }

    // Nettoyage au démontage du composant
    return () => {
      const container = document.getElementById("volume-container")
      if (container) container.innerHTML = ""
    }
  }, [])
  return (
    <div className="p-6 mx-auto">
      {/* <h2 className="text-lg font-semibold mb-4">Paiement Volume</h2> */}
      <div id="volume-container" />
    </div>
  )
}

export default VolumePayment